export default {
  profile: '个人中心',
  settings: '系统设置',
};
